import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PassengerDocsaComponent } from './passenger-docsa.component';
import { AccordionModule } from '../accordion/accordion.module';
import { InputFieldModule } from '../input-field/input-field.module';
import { InputSelectModule } from '../input-select/input-select.module';
import { DateRangeModule } from '../date-range/date-range.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { PipesModule } from 'src/app/core/pipes/pipes.module';



@NgModule({
  declarations: [PassengerDocsaComponent],
  imports: [
    CommonModule,
    AccordionModule,
    InputFieldModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    InputSelectModule,
    DateRangeModule,
    PipesModule
  ],
  exports: [PassengerDocsaComponent]
})
export class PassengerDocsaModule { }
